import { useMutation, useQueryClient } from '@tanstack/react-query';

interface DeleteCustomCategoryParams {
  categoryId: number;
  recordClassName: string;
}

/**
 * カスタムカテゴリ削除用のフック
 */
export default function useDeleteCustomCategory() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ categoryId }: DeleteCustomCategoryParams) => {
      const response = await fetch(`/agent/api/custom_categories/${categoryId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token':
            document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.errors?.[0] || '削除に失敗しました');
      }

      return response.json();
    },
    onSuccess: (data, variables) => {
      // カテゴリ一覧のキャッシュを無効化して再取得
      queryClient.invalidateQueries({ queryKey: ['custom_categories', variables.recordClassName] });
    },
  });
}
